import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfiguration } from 'app/app-configuration';
import { SendingReportModel, SendingReportOptionsModel, } from './model/sending-report.model';

@Injectable()
export class SendingReportRestService {
  private readonly controllerUrl = `${this.appConfiguration.serverApiUrl}/secured/smart-reports`;

  constructor(private httpClient: HttpClient,
              private appConfiguration: AppConfiguration) {
  }

  findAll(smartReportId: number): Observable<SendingReportModel[]> {
    return this.httpClient.get<SendingReportModel[]>(`${this.controllerUrl}/${smartReportId}/sending-reports`);
  }

  getOptions(smartReportId: number, templateId: number): Observable<SendingReportOptionsModel> {
    const params = new HttpParams().set('templateId', templateId);
    return this.httpClient.get<SendingReportOptionsModel>(`${this.controllerUrl}/${smartReportId}/sending-reports/options`, {params});
  }

  create(smartReportId: number, payload: SendingReportModel): Observable<SendingReportModel> {
    return this.httpClient.post<SendingReportModel>(`${this.controllerUrl}/${smartReportId}/sending-reports`, payload);
  }

  update(smartReportId: number, sendingReportId: number, payload: SendingReportModel): Observable<SendingReportModel> {
    return this.httpClient.put<SendingReportModel>(`${this.controllerUrl}/${smartReportId}/sending-reports/${sendingReportId}`, payload);
  }

  delete(smartReportId: number, sendingReportId: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.controllerUrl}/${smartReportId}/sending-reports/${sendingReportId}`);
  }

  sendNow(smartReportId: number, sendingReportId: number): Observable<void> {
    return this.httpClient.post<void>(`${this.controllerUrl}/${smartReportId}/sending-reports/${sendingReportId}/send`, {});
  }
}

